import $ from "jquery";
import debug from 'bows/dist/bows.min.js';

// const $body = $('body');
const log = debug("in-page-menu");
const inPageSection = $('.in-page');
const inPageContent = $('.in-page__content');
const inPageMenu = $('.in-page__menu ul');
let inPageExtra = '';
let inPageExtraBtn = '';
let $extraMenuList = '';


// Get .in-page__menu li items and check against width of container (in-page__menu).
// Create <button>...</button> and <ul><li></li>...</ul>
// Add items to the extra menu list when width is greater than container
// functionality to toggle the extra items button
// Scroll event to determine when jump link item is at corresponding anchor
// Smaller screens, everything is in dropdown

function linkStyle() {
	inPageMenu.find('a').each(function (index) {
		$(this).addClass('in-page__link nls');
	});
	inPageMenu.find('li').each(function (index) {
		$(this).addClass('in-page__list-item');
	});
}

function createExtraMenu() {
	linkStyle();

	let label = inPageSection.attr('data-label');

	let html = `
			<div class="in-page__extra">
				<button class="in-page__more" type="button"><span class="in-page__more-label">${label}</span><span class="in-page__more-icon">&hellip;</span></button>
				<div class="in-page__dropdown">
					<ul class="in-page__dropdown-list"></ul>
				</div>
			</div>
	`;
	inPageContent.append(html);
	inPageExtraBtn = $('.in-page__more');
	inPageExtra = $('.in-page__extra');
	$extraMenuList = $('.in-page__dropdown-list');
	inPageMenu.find('li').each(function (index) {

		$(this).attr('data-num', index);
	});
	let ddItems = inPageMenu.find('li').clone();
	$extraMenuList.append(ddItems);
	widthCheck();
	extraMenuToggleClick();
}

function updateDropDown(firstHidden) {
	$extraMenuList.find('.in-page--show').removeClass('in-page--show');
	$extraMenuList.find(`[data-num=${firstHidden}]`).addClass('in-page--show').nextAll().addClass('in-page--show');
}


function widthCheck() {
	let inPageContainWidth = inPageMenu.outerWidth();
	let itemsWidth = 0;
	let firstHidden = null;
	$('.in-page--hidden').removeClass('in-page--hidden');
	inPageMenu.find('li').each(function () {
		let $this = $(this);
		itemsWidth += $this.outerWidth(true);
		log(inPageContainWidth);
		log(itemsWidth);
		if ((inPageContainWidth - itemsWidth) < 0) {
			$this.addClass('in-page--hidden').nextAll().addClass('in-page--hidden');
			if (firstHidden == null) {
				firstHidden = $this.data('num');
				updateDropDown(firstHidden);
			}
			inPageExtra.addClass('in-page__extra--visible');
		} else {
			inPageExtra.removeClass('in-page__extra--visible');
		}
	});
}

function extraMenuToggleClick() {
	inPageExtraBtn.on('click', function () {
		$(this).closest(inPageExtra).toggleClass('in-page__extra--open');
	});
	$(document).on('click', function (event) {
		if (!$(event.target).closest('.in-page__extra').length && !$(event.target).is('.in-page__extra')) {
			inPageExtra.removeClass('in-page__extra--open');
		}
	});

	$('body').on('click', '.in-page__dropdown-list a', function () {
		$(this).closest(inPageExtra).removeClass('in-page__extra--open');
	});
}

function doJumps() {
	$('body').on('click', '.in-page__link', function () {
		let where = $(this).attr('href');
		let $where = $(`${where}`);
		history.pushState('', '', where);

		// if a div is hidden (inactive tab per say) go to it's closest visible parent node
		if (!$where.is(':visible')) {
			$where = $where.closest(':visible');
		}

		let $whereOffset = $where.offset();

		$('html, body').animate({
			scrollTop: $whereOffset.top - 300
		}, 350, function () {
			$where.attr('tabindex', -1).focus();
			$('.active').removeClass('active');
			$(`.in-page__link[href="${where}"]`).addClass('active');
		});
	});
}

function setInPageData() {
	inPageSection.find('.in-page__link').each(function () {
		let target = $(this).attr('href');
		let targetID = target.substring(1, target.length);
		log(targetID);
		$('body').find('#' + targetID).attr('data-target', targetID);

	});

}

function setObservers() {
	setInPageData();
	let jumpMenus = document.querySelectorAll('[data-target]');
	log(jumpMenus)
	let config = {
		rootMargin: '0px',
		threshold: [0.1, 0.25, 0.5, 0.75, 1]
	}


	let observer = new IntersectionObserver(entries => {

		entries.forEach(entry => {
			let target_id = entry.target.id;
			let targetOffsetTop = $(`#${target_id}`).offset().top - 150;
			let scroll = $(window).scrollTop()
			log(targetOffsetTop + ' - ' + target_id);
			log(scroll);

			if (targetOffsetTop < scroll) {
				$('.active').removeClass('active');
				$(`.in-page__link[href="#${target_id}"]`).addClass('active');
			}
		})
	}, config);

	jumpMenus.forEach(jm => {
		observer.observe(jm);
	})

	//look href in in-page witch corresponding id
	//add
}

function inPageNav() {
	if (inPageSection.length > 0) {
		createExtraMenu();
		doJumps();
		setObservers();

		$(window).on('resize', function () {
			if (window.innerWidth >= 600) {
				widthCheck();
			}
		});
	}
}

document.addEventListener('DOMContentLoaded', () => inPageNav());

export default {
	inPageNav
};



